import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import CustomFormAutoComplete from './components/CustomFormAutoComplete'

export default function CustomFormSingleSelectionListQuestion(props: CustomFormViewerQuestionProps) {
  return <CustomFormAutoComplete {...props} />
}
